export const flattenObjectValues = obj => {
  let values = [];
  Object.values(obj).forEach(value => {
    if (typeof value === 'object') {
      values = [...values, ...flattenObjectValues(value)];
    } else {
      values.push(value);
    }
  });
  return values;
};

// 更新する企業情報の作成
export const createCompanyData = (
  confirmData,
  confirmDataError,
  enableUpdateLicense,
  enableDisplayLicense,
) => {
  let companyData = [
    {
      id: confirmData.companyId,
      lat: confirmData.lat,
      lng: confirmData.lng,
      operatorDeviceLimit: confirmData.operatorDeviceLimit,
      downloadFileNamePatternId: confirmData.downloadFileNamePatternId,
    },
  ];

  if (
    enableUpdateLicense &&
    !flattenObjectValues(confirmDataError).some(Boolean)
  ) {
    companyData = [
      {
        ...companyData[0],
        operatorDeviceLimit: confirmData.operatorDeviceLimit,
        userLicense: {
          contractNumber: Number(confirmData.userLicense.contractNumber),
        },
        voiceAnalysisLicense: {
          enabled: confirmData.voiceAnalysisLicense.enabled,
          autoAnalysisEnabled:
            confirmData.voiceAnalysisLicense.autoAnalysisEnabled,
          contractNumber: Number(
            confirmData.voiceAnalysisLicense.contractNumber,
          ),
        },
        ocrLicense: {
          enabled: confirmData.ocrLicense.enabled,
          autoAnalysisEnabled: confirmData.ocrLicense.autoAnalysisEnabled,
          contractNumber: Number(confirmData.ocrLicense.contractNumber),
        },
        storageLicense: {
          storageType: confirmData.storageLicense.storageType,
          customNumber: Number(confirmData.storageLicense.customNumber),
        },
        remoteSupportLicense: {
          enabled: confirmData.remoteSupportLicense.enabled,
          contractNumber: Number(
            confirmData.remoteSupportLicense.contractNumber,
          ),
        },
      },
    ];
  } else if (
    enableDisplayLicense &&
    !confirmDataError.lat &&
    !confirmDataError.lng
  ) {
    companyData = [
      {
        ...companyData[0],
        voiceAnalysisLicense: {
          autoAnalysisEnabled:
            confirmData.voiceAnalysisLicense.autoAnalysisEnabled,
        },
        ocrLicense: {
          autoAnalysisEnabled: confirmData.ocrLicense.autoAnalysisEnabled,
        },
      },
    ];
  }

  return companyData;
};
